import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCrownFilled = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M1.992 6.914c0-.406.18-.703.54-.89.359-.188.702-.165 1.03.07l2.86 2.015c.172.11.36.164.562.164.22 0 .414-.054.586-.164l3.867-2.718c.172-.11.36-.164.563-.164.203 0 .39.054.563.164l3.867 2.718c.172.11.36.164.562.164.219 0 .414-.054.586-.164l2.86-2.015c.328-.235.671-.258 1.03-.07.36.187.54.484.54.89v10.078c0 .563-.195 1.04-.586 1.43-.39.39-.867.586-1.43.586H4.008c-.563 0-1.04-.195-1.43-.586a1.945 1.945 0 0 1-.586-1.43V6.914z" }),
});

export { IconCrownFilled };
